import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { take9j4462mea726 as take } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  plus2opbwe063z9pg as plus,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atCenterEnd17oomnncsh8vk as get_atCenterEnd,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_atCenterStart2eaw4isrpvpjb as get_atCenterStart,
  get_atBottomCenterphs4xo2ro2dv as get_atBottomCenter,
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
  get_atBottomEnd1uhyy6gazj2pk as get_atBottomEnd,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_session9cytjmfbg8nd as get_session,
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
} from '../../../../sdk/UserSession.mjs';
import { isUnread2u0ehyt0ioouz as isUnread } from '../../../../extensions/HasReadBy.ext.mjs';
import { unreadIconWhen1430ixd91bo9h as unreadIconWhen } from '../../iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  MessageSemantic26vy91vxbjwf0 as MessageSemantic,
  get_lightSection4cpu8okr0w14 as get_lightSection,
} from '../../../theming/sections.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
  title1nssp3ryhwuqj as title,
} from '../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  formatRelative8nj0p568e3ja as formatRelative,
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import {
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
} from '../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  Duration__toLong_impl_shr43i2exoqry3vqnf5 as Duration__toLong_impl_shr43i,
  _Duration___get_inWholeSeconds__impl__hpy7b32fu0rnoit26fw as _Duration___get_inWholeSeconds__impl__hpy7b3,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  MessageSectionSubHeaderSemantic_getInstance2a24vkxcf46oz as MessageSectionSubHeaderSemantic_getInstance,
  InitialIconSemantic_getInstanceaqd9z1nvlka3 as InitialIconSemantic_getInstance,
  RemoveOutline_getInstance2r2ekg5cxorga as RemoveOutline_getInstance,
} from '../../../theming/appTheme.mjs';
import {
  get_padded3m3frjnjujncx as get_padded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../theming/separators.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  ImageRemote256pcav1ipbca as ImageRemote,
  timesx4ey3un7ihw1 as times,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  divkhq3vjih9fcw as div,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../nav/crowpay.mjs';
import {
  toList3jhuyej2anx2q as toList,
  getOrNull1go7ef9ldk0df as getOrNull,
  reversed22y3au42jl32b as reversed,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_fullName2ompl3bj5l3sh as get_fullName } from '../../../../../../../crowpay-shared/com/crowpay/extensions/User.ext.shared.mjs';
import {
  MessageReply3razfyxlh5p4t as MessageReply,
  ProjectMessage3vmbacgk5u7x3 as ProjectMessage,
} from '../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../screens/common/ProjectView.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { RecyclerViewRendererSet341fhovxcnndi as RecyclerViewRendererSet } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/RecyclerViewRendererSet.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { And3abx79zpqd7r8 as And } from '../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import {
  get_project1t10doy5antl1 as get_project,
  get_referencesPayApp2j107w4s6lx3b as get_referencesPayApp,
  get_referencesChangeRequest3ru7mjlfmk3mg as get_referencesChangeRequest,
  get_sent1fielv150x6ow as get_sent,
} from '../../../../../../../crowpay-shared/com/crowpay/ProjectMessageFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  ConstantLimitReadable29q2jwoe6byet as ConstantLimitReadable,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  resize3py5p2yrjp6p7 as resize,
} from '../../../../utils/utils.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { Companion_instanceyb6grjkdzphm as Companion_instance } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/RecyclerViewData.mjs';
import {
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../utils/JumpTo.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function truncate(_this__u8e3s4, take_0, postfix) {
  postfix = postfix === VOID ? '...' : postfix;
  return _this__u8e3s4.length > take_0 ? take(_this__u8e3s4, take_0) + postfix : _this__u8e3s4;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.cgw_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.bgw_1.egw_1(tmp$ret$0.hgw_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function messageBlock($this, _this__u8e3s4, data) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_dp(5));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_AppDimensions().og2_1);
  get_centered(view_0);
  unreadIconWhen(view_0, ($this$unreadIconWhen) => isUnread($this$unreadIconWhen.daj(data).hgw_1, $this$unreadIconWhen.daj(get_session()).gfv_1));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance();
  renderUserName($this.jgw_1, view_0, data);
  view.hbb(p_0, view_0);
  var tmp = view.jbb(MessageSemantic().sgt(false));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  var tmp_0 = get_compact(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(true);
  renderReplyOrReference($this.jgw_1, view_2, data);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl_1(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_1(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp$ret$5 = $this$reactiveScope.daj(data).hgw_1.n7p_1;
    this_0.set(tmp$ret$5);
    return Unit_instance;
  });
  view_2.hbb(p_3, view_3);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_0, view_2);
  view.hbb(p_1, view_1);
  view.lbb(tmp, view_1);
  var tmp_3 = get_compact(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.zbm(false);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(SmallBodySemantic_getInstance()));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_2(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_2(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$19 = formatRelative($this$reactiveScope.daj(data).hgw_1.m7p_1);
    this_1.set(tmp$ret$19);
    return Unit_instance;
  });
  view_4.hbb(p_5, view_5);
  smallBody(view_4, '\u2022');
  var tmp_6 = get_textButton(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Button())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.gbb(p_6, view_6);
  view_6.gba(get_px(0));
  view_6.bb9(get_px(0));
  smallBody(view_6, 'Reply');
  onClick(view_6, 'reply', VOID, ProjectMessageThread$MessageRenderers$OthersMessage$messageBlock$slambda_0($this.jgw_1, data));
  view_4.hbb(p_6, view_6);
  view_4.lbb(tmp_6, view_6);
  view.hbb(p_4, view_4);
  view.lbb(tmp_3, view_4);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ProjectMessageThread$MessageRenderers$OthersMessage$messageBlock$slambdaClass;
function ProjectMessageThread$MessageRenderers$OthersMessage$messageBlock$slambda() {
  if (ProjectMessageThread$MessageRenderers$OthersMessage$messageBlock$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $data) {
        this.bgw_1 = this$0;
        this.cgw_1 = $data;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectMessageThread$MessageRenderers$OthersMessage$messageBlock$slambdaClass = $;
  }
  return ProjectMessageThread$MessageRenderers$OthersMessage$messageBlock$slambdaClass;
}
function ProjectMessageThread$MessageRenderers$OthersMessage$messageBlock$slambda_0(this$0, $data) {
  var i = new (ProjectMessageThread$MessageRenderers$OthersMessage$messageBlock$slambda())(this$0, $data);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function renderDateTimeSubHeader($this, _this__u8e3s4, window_0) {
  var tmp = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    var window_1 = $this$shownWhen.daj(window_0);
    return window_1.ggw_1 == null ? true : Duration__toLong_impl_shr43i(window_1.hgw_1.m7p_1.v26(window_1.ggw_1.m7p_1), DurationUnit_SECONDS_getInstance()) > 3600n ? true : false;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var tmp_0 = view.kbb(view.kbb(get_centered(view), view.jbb(MessageSectionSubHeaderSemantic_getInstance())), get_padded(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  var tmp_1 = view_0.kbb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(3)), get_centered(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  greySeparator(view_1);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_1, view_1);
  var tmp_2 = get_centered(view_0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl_3(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_3(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp$ret$4 = format($this$reactiveScope.daj(window_0).hgw_1.m7p_1, Formats_getInstance().l8z_1);
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  view_2.dbs(Align_Center_getInstance());
  view_0.hbb(p_2, view_2);
  view_0.lbb(tmp_2, view_2);
  var tmp_5 = view_0.kbb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(3)), get_centered(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.gbb(p_3, view_3);
  view_3.zbm(true);
  greySeparator(view_3);
  view_0.hbb(p_3, view_3);
  view_0.lbb(tmp_5, view_3);
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
}
function renderUserName($this, _this__u8e3s4, window_0) {
  var tmp = _this__u8e3s4.kbb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    var window_1 = $this$shownWhen.daj(window_0);
    return window_1.ggw_1 == null || !window_1.ggw_1.i7p_1.equals(window_1.hgw_1.i7p_1) || Duration__toLong_impl_shr43i(window_1.hgw_1.m7p_1.v26(window_1.ggw_1.m7p_1), DurationUnit_SECONDS_getInstance()) > 600n;
  }), get_compact(_this__u8e3s4));
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(SmallBodySemantic_getInstance()));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_4(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_4(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.daj(window_0).hgw_1.j7p_1;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
}
function renderUserIcon($this, _this__u8e3s4, window_0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  var tmp = KMutableProperty0();
  var tmp_0 = RowOrCol$_get_visible_$ref_m9hbzh(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('visible', 0, tmp, tmp_0, RowOrCol$_set_visible_$ref_80wucf(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var window_1 = $this$reactiveScope.daj(window_0);
    var tmp$ret$0 = window_1.ggw_1 == null || !window_1.ggw_1.i7p_1.equals(window_1.hgw_1.i7p_1) || Duration__toLong_impl_shr43i(window_1.hgw_1.m7p_1.v26(window_1.ggw_1.m7p_1), DurationUnit_SECONDS_getInstance()) > 600n;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  var tmp_1 = shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp = $this$shownWhen.daj(window_0).hgw_1.k7p_1;
    return (tmp == null ? null : new (ServerFile())(tmp)) == null;
  });
  var tmp0_height = get_rem_0(1.9);
  var tmp_2 = view.kbb(view.kbb(tmp_1, sizeConstraints(view, VOID, VOID, VOID, VOID, 1.0, VOID, tmp0_height)), view.jbb(InitialIconSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.dbs(Align_Center_getInstance());
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl_5(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_5(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    // Inline function 'kotlin.let' call
    var it = $this$reactiveScope.daj($this$reactiveScope.eaj(get_rawSession()).rfw_1);
    var tmp$ret$4 = take(it.h88_1, 1) + take(it.i88_1, 1);
    this_1.set(tmp$ret$4);
    return Unit_instance;
  });
  view.hbb(p_0, view_0);
  view.lbb(tmp_2, view_0);
  var tmp_5 = shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp = $this$shownWhen.daj(window_0).hgw_1.k7p_1;
    return !((tmp == null ? null : new (ServerFile())(tmp)) == null);
  });
  var tmp1_height = get_rem(2);
  var tmp2_width = get_rem(2);
  var tmp_6 = view.kbb(tmp_5, sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, tmp2_width, tmp1_height));
  // Inline function 'com.lightningkite.kiteui.views.direct.image' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (ImageView())(view);
  var tmp_7 = KMutableProperty0();
  var tmp_8 = ImageView$_get_source_$ref_ain7z1(this_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('source', 0, tmp_7, tmp_8, ImageView$_set_source_$ref_4jld67(this_2));
  reactiveScope(view, ($this$reactiveScope) => {
    var logo = $this$reactiveScope.daj(window_0).hgw_1.k7p_1;
    var tmp;
    var tmp_0;
    var tmp_1 = logo;
    if (!((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null)) {
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = _ServerFile___get_location__impl__ddyqaq(logo);
      tmp_0 = !isBlank(this_0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new (ImageRemote())(_ServerFile___get_location__impl__ddyqaq(logo));
    } else {
      tmp = null;
    }
    var tmp$ret$10 = tmp;
    this_3.set(tmp$ret$10);
    return Unit_instance;
  });
  this_2.gbu('Sender Icon');
  this_2.bbb();
  view.lbb(tmp_6, this_2);
  _this__u8e3s4.hbb(p, view);
}
function renderReplyOrReference($this, _this__u8e3s4, message) {
  var tmp = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => !($this$shownWhen.daj(message).hgw_1.p7p_1 == null));
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(SmallBodySemantic_getInstance()));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_6(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_6(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj(message).hgw_1.p7p_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i9a_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : truncate(tmp1_safe_receiver, 100);
    var tmp$ret$0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
}
var MyMessageClass;
function MyMessage() {
  if (MyMessageClass === VOID) {
    class $ {
      constructor($outer) {
        this.kgw_1 = $outer;
      }
      lgw(viewWriter, data, index) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(viewWriter.pc());
        var tmp0_elvis_lhs = viewWriter.ebb_1;
        var p = tmp0_elvis_lhs == null ? viewWriter : tmp0_elvis_lhs;
        viewWriter.gbb(p, view);
        view.zbm(true);
        view.bb9(get_rem(0));
        renderDateTimeSubHeader(this.kgw_1, view, data);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_0.hbb(p_1, view_1);
        var tmp = get_expanding(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        var tmp_0 = get_atCenterEnd(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(true);
        view_3.bb9(get_dp(5));
        var tmp_1 = view_3.jbb(MessageSemantic().sgt(true));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Frame())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        var tmp_2 = get_compact(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.zbm(true);
        renderReplyOrReference(this.kgw_1, view_5, data);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextView())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.lba(view_6.qb6_1.abf(BodySemantic_getInstance()));
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl(view_6);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(view_6));
        reactiveScope(view_6, ($this$reactiveScope) => {
          var tmp$ret$3 = $this$reactiveScope.daj(data).hgw_1.n7p_1;
          this_0.set(tmp$ret$3);
          return Unit_instance;
        });
        view_5.hbb(p_6, view_6);
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_2, view_5);
        view_3.hbb(p_4, view_4);
        view_3.lbb(tmp_1, view_4);
        var tmp_5 = get_atEnd(view_3);
        var tmp_6 = view_3.kbb(tmp_5, shownWhen(view_3, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.let' call
          var destruct = $this$shownWhen.daj(data);
          var cur = destruct.df();
          var next = destruct.ww();
          return next == null || _Duration___get_inWholeSeconds__impl__hpy7b3(next.m7p_1.v26(cur.m7p_1)) > 60n;
        }));
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_7 = view_3.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_3 : tmp0_elvis_lhs_7;
        view_3.gbb(p_7, view_7);
        view_7.lba(view_7.qb6_1.abf(SmallBodySemantic_getInstance()));
        var tmp_7 = KMutableProperty0();
        var tmp_8 = TextView$_get_content_$ref_4pzcwl_0(view_7);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_0(view_7));
        reactiveScope(view_7, ($this$reactiveScope) => {
          var tmp$ret$19 = formatRelative($this$reactiveScope.daj(data).hgw_1.m7p_1);
          this_1.set(tmp$ret$19);
          return Unit_instance;
        });
        view_3.hbb(p_7, view_7);
        view_3.lbb(tmp_6, view_7);
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_0, view_3);
        view_0.hbb(p_2, view_2);
        view_0.lbb(tmp, view_2);
        view.hbb(p_0, view_0);
        viewWriter.hbb(p, view);
        return view;
      }
      pdg(viewWriter, data, index) {
        return this.lgw(viewWriter, data, index);
      }
    }
    initMetadataForClass($, 'MyMessage');
    MyMessageClass = $;
  }
  return MyMessageClass;
}
var OthersMessageClass;
function OthersMessage() {
  if (OthersMessageClass === VOID) {
    class $ {
      constructor($outer) {
        this.jgw_1 = $outer;
      }
      lgw(viewWriter, data, index) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(viewWriter.pc());
        var tmp0_elvis_lhs = viewWriter.ebb_1;
        var p = tmp0_elvis_lhs == null ? viewWriter : tmp0_elvis_lhs;
        viewWriter.gbb(p, view);
        view.zbm(true);
        view.bb9(get_rem(0));
        renderDateTimeSubHeader(this.jgw_1, view, data);
        if (get_viewIsWide(view)) {
          var tmp = sizeConstraints(view, VOID, times(get_AppDimensions().gg2_1, 0.8));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(false);
          view_0.bb9(get_rem_0(0.5));
          renderUserIcon(this.jgw_1, view_0, data);
          messageBlock(this, view_0, data);
          view.hbb(p_0, view_0);
          view.lbb(tmp, view_0);
        } else {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.zbm(false);
          var tmp_0 = get_expanding(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Frame())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          view_2.lbb(get_atCenterStart(view_2), messageBlock(this, view_2, data));
          view_1.hbb(p_2, view_2);
          view_1.lbb(tmp_0, view_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Space())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.gbb(p_3, view_3);
          view_1.hbb(p_3, view_3);
          view.hbb(p_1, view_1);
        }
        viewWriter.hbb(p, view);
        return view;
      }
      pdg(viewWriter, data, index) {
        return this.lgw(viewWriter, data, index);
      }
    }
    initMetadataForClass($, 'OthersMessage');
    OthersMessageClass = $;
  }
  return OthersMessageClass;
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function RowOrCol$_get_visible_$ref_m9hbzh(p0) {
  return () => p0.ab9();
}
function RowOrCol$_set_visible_$ref_80wucf(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ImageView$_get_source_$ref_ain7z1(p0) {
  return () => p0.g2i();
}
function ImageView$_set_source_$ref_4jld67(p0) {
  return (_this__u8e3s4) => {
    p0.qda(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().tfg_1.vf9(toList($this.mgw_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.associateBy' call
  var this_1 = tmp_0;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp$ret$1 = element.g7p_1;
    destination.s3(tmp$ret$1, element);
  }
  var updatedMessages = destination;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_1 = await_0(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1.lfw_1;
  var tmp_3 = (it) => updatedMessages.q3().t1(it.g7p_1);
  tmp_2.eeo(tmp_3, (it) => updatedMessages.p3(it.g7p_1));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xgw_1.tgw_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  $this.wgw_1.wdj(get_lastIndex(tmp$ret$0), Align_End_getInstance(), false);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zgw_1.tgw_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  $this.ygw_1.wdj(get_lastIndex(tmp$ret$0), Align_End_getInstance(), true);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp1_project = $this.agx_1.ogw_1;
  var tmp2_sender = session.gfv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = session.rfw_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$1 = tmp_0;
  var tmp3_senderName = get_fullName(tmp$ret$1);
  var tmp4_message = $this.agx_1.ugw_1.f2();
  var tmp0_safe_receiver = $this.agx_1.vgw_1.f2();
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = MessageReply().l9a(tmp0_safe_receiver);
  }
  var tmp5_replyingToMessage = tmp_1;
  var tmp6_clientMessage = !$this.agx_1.ngw_1.equals(ProjectLens_Contractor_getInstance());
  var tmp_2 = session.lfw_1.oft(new (ProjectMessage())(VOID, tmp1_project, tmp2_sender, tmp3_senderName, VOID, tmp6_clientMessage, VOID, tmp4_message, VOID, tmp5_replyingToMessage), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.agx_1.vgw_1.oam(null);
  $this.agx_1.ugw_1.oam('');
  return Unit_instance;
}
function clearButton($this, _this__u8e3s4) {
  var tmp = get_secondaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Button$_get_enabled_$ref_61t7nx(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = $this$reactiveScope.daj($this.ugw_1);
    var tmp$ret$1 = !isBlank(this_1);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  specCenteredText(view, 'Clear');
  onClick(view, 'discard', VOID, ProjectMessageThread$Renderer$clearButton$slambda_0($this));
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function sendButton($this, _this__u8e3s4) {
  var tmp = get_primaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Button$_get_enabled_$ref_61t7nx_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = $this$reactiveScope.daj($this.ugw_1);
    var tmp$ret$1 = !isBlank(this_1);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  specCenteredText(view, 'Send');
  onClick(view, 'send', VOID, ProjectMessageThread$Renderer$sendButton$slambda_0($this));
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
var ProjectMessageThread$Renderer$renderTo$lambda$slambdaClass;
function ProjectMessageThread$Renderer$renderTo$lambda$slambda() {
  if (ProjectMessageThread$Renderer$renderTo$lambda$slambdaClass === VOID) {
    class $ {
      constructor($nowRead) {
        this.mgw_1 = $nowRead;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectMessageThread$Renderer$renderTo$lambda$slambdaClass = $;
  }
  return ProjectMessageThread$Renderer$renderTo$lambda$slambdaClass;
}
function ProjectMessageThread$Renderer$renderTo$lambda$slambda_0($nowRead) {
  var i = new (ProjectMessageThread$Renderer$renderTo$lambda$slambda())($nowRead);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ProjectMessageThread$Renderer$renderTo$slambdaClass;
function ProjectMessageThread$Renderer$renderTo$slambda() {
  if (ProjectMessageThread$Renderer$renderTo$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.bgx_1 = this$0;
      }
      cgx(it, $completion) {
        this.bgx_1.vgw_1.oam(it);
      }
      s2(p1, $completion) {
        return this.cgx(p1 instanceof ProjectMessage() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectMessageThread$Renderer$renderTo$slambdaClass = $;
  }
  return ProjectMessageThread$Renderer$renderTo$slambdaClass;
}
function ProjectMessageThread$Renderer$renderTo$slambda_0(this$0) {
  var i = new (ProjectMessageThread$Renderer$renderTo$slambda())(this$0);
  var l = (it, $completion) => i.cgx(it, $completion);
  l.$arity = 1;
  return l;
}
var ProjectMessageThread$Renderer$renderTo$slambdaClass_0;
function ProjectMessageThread$Renderer$renderTo$slambda_1() {
  if (ProjectMessageThread$Renderer$renderTo$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$recyclerView, this$0) {
        this.wgw_1 = $$this$recyclerView;
        this.xgw_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ProjectMessageThread$Renderer$renderTo$slambdaClass_0 = $;
  }
  return ProjectMessageThread$Renderer$renderTo$slambdaClass_0;
}
function ProjectMessageThread$Renderer$renderTo$slambda_2($$this$recyclerView, this$0) {
  var i = new (ProjectMessageThread$Renderer$renderTo$slambda_1())($$this$recyclerView, this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return () => p0.yb8();
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ProjectMessageThread$Renderer$renderTo$slambdaClass_1;
function ProjectMessageThread$Renderer$renderTo$slambda_3() {
  if (ProjectMessageThread$Renderer$renderTo$slambdaClass_1 === VOID) {
    class $ {
      constructor($messageRecycler, this$0) {
        this.ygw_1 = $messageRecycler;
        this.zgw_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectMessageThread$Renderer$renderTo$slambdaClass_1 = $;
  }
  return ProjectMessageThread$Renderer$renderTo$slambdaClass_1;
}
function ProjectMessageThread$Renderer$renderTo$slambda_4($messageRecycler, this$0) {
  var i = new (ProjectMessageThread$Renderer$renderTo$slambda_3())($messageRecycler, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ProjectMessageThread$Renderer$renderTo$slambdaClass_2;
function ProjectMessageThread$Renderer$renderTo$slambda_5() {
  if (ProjectMessageThread$Renderer$renderTo$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0) {
        this.dgx_1 = this$0;
      }
      uao($completion) {
        this.dgx_1.vgw_1.oam(null);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectMessageThread$Renderer$renderTo$slambdaClass_2 = $;
  }
  return ProjectMessageThread$Renderer$renderTo$slambdaClass_2;
}
function ProjectMessageThread$Renderer$renderTo$slambda_6(this$0) {
  var i = new (ProjectMessageThread$Renderer$renderTo$slambda_5())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ProjectMessageThread$Renderer$clearButton$slambdaClass;
function ProjectMessageThread$Renderer$clearButton$slambda() {
  if (ProjectMessageThread$Renderer$clearButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.egx_1 = this$0;
      }
      uao($completion) {
        this.egx_1.ugw_1.oam('');
        this.egx_1.vgw_1.oam(null);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectMessageThread$Renderer$clearButton$slambdaClass = $;
  }
  return ProjectMessageThread$Renderer$clearButton$slambdaClass;
}
function ProjectMessageThread$Renderer$clearButton$slambda_0(this$0) {
  var i = new (ProjectMessageThread$Renderer$clearButton$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ProjectMessageThread$Renderer$sendButton$slambdaClass;
function ProjectMessageThread$Renderer$sendButton$slambda() {
  if (ProjectMessageThread$Renderer$sendButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.agx_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectMessageThread$Renderer$sendButton$slambdaClass = $;
  }
  return ProjectMessageThread$Renderer$sendButton$slambdaClass;
}
function ProjectMessageThread$Renderer$sendButton$slambda_0(this$0) {
  var i = new (ProjectMessageThread$Renderer$sendButton$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ProjectMessageThread$Dialog$render$slambdaClass;
function ProjectMessageThread$Dialog$render$slambda() {
  if (ProjectMessageThread$Dialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectMessageThread$Dialog$render$slambdaClass = $;
  }
  return ProjectMessageThread$Dialog$render$slambdaClass;
}
function ProjectMessageThread$Dialog$render$slambda_0() {
  var i = new (ProjectMessageThread$Dialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ProjectMessageThread$Dialog$render$slambdaClass_0;
function ProjectMessageThread$Dialog$render$slambda_1() {
  if (ProjectMessageThread$Dialog$render$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectMessageThread$Dialog$render$slambdaClass_0 = $;
  }
  return ProjectMessageThread$Dialog$render$slambdaClass_0;
}
function ProjectMessageThread$Dialog$render$slambda_2() {
  var i = new (ProjectMessageThread$Dialog$render$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MessageWindowClass;
function MessageWindow() {
  if (MessageWindowClass === VOID) {
    class $ {
      constructor(previous, current, next) {
        this.ggw_1 = previous;
        this.hgw_1 = current;
        this.igw_1 = next;
      }
      df() {
        return this.hgw_1;
      }
      ww() {
        return this.igw_1;
      }
      toString() {
        return 'MessageWindow(previous=' + toString(this.ggw_1) + ', current=' + this.hgw_1.toString() + ', next=' + toString(this.igw_1) + ')';
      }
      hashCode() {
        var result = this.ggw_1 == null ? 0 : this.ggw_1.hashCode();
        result = imul(result, 31) + this.hgw_1.hashCode() | 0;
        result = imul(result, 31) + (this.igw_1 == null ? 0 : this.igw_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MessageWindow()))
          return false;
        if (!equals(this.ggw_1, other.ggw_1))
          return false;
        if (!this.hgw_1.equals(other.hgw_1))
          return false;
        if (!equals(this.igw_1, other.igw_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MessageWindow');
    MessageWindowClass = $;
  }
  return MessageWindowClass;
}
var MessageRenderersClass;
function MessageRenderers() {
  if (MessageRenderersClass === VOID) {
    class $ {
      constructor(lens, onReply) {
        this.dgw_1 = lens;
        this.egw_1 = onReply;
        var tmp = this;
        var tmp_0;
        switch (this.dgw_1.b4_1) {
          case 0:
            tmp_0 = false;
            break;
          case 1:
            tmp_0 = true;
            break;
          case 2:
            tmp_0 = true;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp.fgw_1 = tmp_0;
      }
      fgx(item) {
        return item.hgw_1.g7p_1;
      }
      kdg(item) {
        return this.fgx(item instanceof MessageWindow() ? item : THROW_CCE());
      }
      ggx(item) {
        return this.fgw_1 === item.hgw_1.l7p_1 ? new (MyMessage())(this) : new (OthersMessage())(this);
      }
      jdg(item) {
        return this.ggx(item instanceof MessageWindow() ? item : THROW_CCE());
      }
    }
    initMetadataForClass($, 'MessageRenderers', VOID, VOID, [RecyclerViewRendererSet()]);
    MessageRenderersClass = $;
  }
  return MessageRenderersClass;
}
var RendererClass;
function Renderer() {
  if (RendererClass === VOID) {
    class $ {
      constructor(lens, project, buffer, increment, requestFocusOnStart) {
        buffer = buffer === VOID ? 15 : buffer;
        increment = increment === VOID ? 100 : increment;
        requestFocusOnStart = requestFocusOnStart === VOID ? false : requestFocusOnStart;
        this.ngw_1 = lens;
        this.ogw_1 = project;
        this.pgw_1 = buffer;
        this.qgw_1 = increment;
        this.rgw_1 = requestFocusOnStart;
        var tmp = this;
        tmp.sgw_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.daj(get_rawSession());
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lfw_1;
          var tmp;
          if (tmp1_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'com.lightningkite.lightningdb.condition' call
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectMessage()), arrayOf([]), false));
            var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it = new (DataClassPathSelf())(tmp$ret$0);
            var tmp_1 = And().v3q([eq(get_project(it), this.ogw_1), eq(get_referencesPayApp(it), null), eq(get_referencesChangeRequest(it), null)]);
            // Inline function 'com.lightningkite.lightningdb.sort' call
            // Inline function 'kotlin.apply' call
            var this_0 = new (SortBuilder())();
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp_2 = serializerOrContextual(createKType(getKClass(ProjectMessage()), arrayOf([]), false));
            var tmp$ret$5 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
            var it_0 = new (DataClassPathSelf())(tmp$ret$5);
            this_0.l4a(get_sent(it_0));
            var tmp$ret$10 = this_0.m1r();
            tmp = tmp1_safe_receiver.mdw(new (Query())(tmp_1, tmp$ret$10, VOID, 100));
          }
          var tmp2_elvis_lhs = tmp;
          return tmp2_elvis_lhs == null ? new (ConstantLimitReadable())(emptyList()) : tmp2_elvis_lhs;
        });
        var tmp_0 = this;
        tmp_0.tgw_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var raw = $this$remember.daj($this$remember.daj(this.sgw_1));
          // Inline function 'kotlin.collections.mapIndexed' call
          // Inline function 'kotlin.collections.mapIndexedTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(raw, 10));
          var index = 0;
          var _iterator__ex2g4s = raw.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var _unary__edvuaz = index;
            index = _unary__edvuaz + 1 | 0;
            var index_0 = checkIndexOverflow(_unary__edvuaz);
            var tmp$ret$11 = new (MessageWindow())(getOrNull(raw, index_0 + 1 | 0), item, getOrNull(raw, index_0 - 1 | 0));
            destination.v(tmp$ret$11);
          }
          var result = destination;
          return result;
        });
        this.ugw_1 = Signal().hak('');
        this.vgw_1 = Signal().hak(null);
      }
      hgx(writer, setTarget) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.ebb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.gbb(p, view);
        view.zbm(true);
        var tmp = view.kbb(get_expanding(view), get_viewIsWide(view) ? sizeConstraints(view, VOID, VOID, get_AppDimensions().eg2_1) : get_expanding(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        var messageRecycler;
        var tmp_0 = get_viewIsWide(view_0) ? Companion_getInstance() : get_expanding(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
        // Inline function 'kotlin.apply' call
        var this_0 = new (Recycler2())(view_0, true);
        var $this$recyclerView = this_0;
        var nowRead = HashSet().ha();
        messageRecycler = $this$recyclerView;
        onRemove($this$recyclerView, () => {
          var tmp;
          if (nowRead.i1()) {
            return Unit_instance;
          }
          var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().xac_1);
          launch(tmp_0, VOID, VOID, ProjectMessageThread$Renderer$renderTo$lambda$slambda_0(nowRead));
          return Unit_instance;
        });
        reactive($this$recyclerView, ($this$reactive) => {
          // Inline function 'kotlin.takeUnless' call
          var this_0 = $this$reactive.daj($this$reactive.daj(this.sgw_1));
          var tmp;
          if (!this_0.i1()) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var tmp0_safe_receiver = tmp;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (isUnread(element, $this$reactive.daj(get_session()).gfv_1)) {
                destination.v(element);
              }
            }
            tmp_0 = destination;
          }
          var tmp1_safe_receiver = tmp_0;
          var tmp_1;
          if (tmp1_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList().u(collectionSizeOrDefault(tmp1_safe_receiver, 10));
            var _iterator__ex2g4s_0 = tmp1_safe_receiver.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var item = _iterator__ex2g4s_0.o1();
              var tmp$ret$5 = item.g7p_1;
              destination_0.v(tmp$ret$5);
            }
            tmp_1 = destination_0;
          }
          var tmp2_safe_receiver = tmp_1;
          var tmp_2;
          if (tmp2_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_2 = nowRead.r1(tmp2_safe_receiver);
          }
          return tmp_2;
        });
        reactive($this$recyclerView, ($this$reactive) => {
          var limiter = $this$reactive.daj(this.sgw_1);
          var tmp;
          if ($this$reactive.daj(limiter).p1() === limiter.re1() && $this$reactive.daj($this$recyclerView.ndd_1) <= this.pgw_1) {
            limiter.qe1(limiter.re1() + this.qgw_1 | 0);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        $this$recyclerView.xde(new (MessageRenderers())(this.ngw_1, ProjectMessageThread$Renderer$renderTo$slambda_0(this)));
        reactive($this$recyclerView, ($this$reactive) => {
          $this$recyclerView.zde(Companion_instance.yde(reversed($this$reactive.daj(this.tgw_1))));
          $this$recyclerView.wdj(get_lastIndex($this$reactive.daj(this.tgw_1)), Align_End_getInstance(), true);
          return Unit_instance;
        });
        launch($this$recyclerView, VOID, VOID, ProjectMessageThread$Renderer$renderTo$slambda_2($this$recyclerView, this));
        view_0.lbb(tmp_0, this_0);
        var tmp_1 = view_0.kbb(get_atBottomCenter(view_0), get_compact(view_0));
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var tmp$ret$13 = view_0.jbb(ButtonSemantic_getInstance());
        var tmp_2 = view_0.kbb(tmp_1, tmp$ret$13);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        var tmp_3 = KMutableProperty0();
        var tmp_4 = Button$_get_shown_$ref_hkylj1(view_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('shown', 0, tmp_3, tmp_4, Button$_set_shown_$ref_bpvuvj(view_1));
        reactiveScope(view_1, ($this$reactiveScope) => {
          var tmp$ret$14 = $this$reactiveScope.daj(messageRecycler.pdd_1) < (get_lastIndex($this$reactiveScope.daj(this.tgw_1)) - 6 | 0);
          this_1.set(tmp$ret$14);
          return Unit_instance;
        });
        smallBody(view_1, 'scroll to bottom');
        onClick(view_1, VOID, VOID, ProjectMessageThread$Renderer$renderTo$slambda_4(messageRecycler, this));
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_2, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_5 = view.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view_2.zbm(true);
        if (setTarget) {
          JumpTo_getInstance().mg3_1.pg4(view_2);
        }
        var tmp_6 = view_2.kbb(view_2.jbb(RemoveOutline_getInstance()), get_lightSection(view_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Frame())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        shownDefaultFalse(view_3, ($this$shownDefaultFalse) => !($this$shownDefaultFalse.daj(this.vgw_1) == null));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
        var tmp_7 = KMutableProperty0();
        var tmp_8 = TextView$_get_content_$ref_4pzcwl_7(view_4);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_7(view_4));
        reactiveScope(view_4, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.daj(this.vgw_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n7p_1;
          var tmp$ret$23 = 'Replying To:\n' + (tmp1_safe_receiver == null ? null : truncate(tmp1_safe_receiver, 200));
          this_2.set(tmp$ret$23);
          return Unit_instance;
        });
        view_3.hbb(p_4, view_4);
        var tmp_9 = get_atTopEnd(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.gbb(p_5, view_5);
        view_5.gba(get_dp(3));
        icon(view_5, resize(Companion_getInstance_0().vcf_1, get_rem(1)), 'Stop Replying');
        onClick(view_5, VOID, VOID, ProjectMessageThread$Renderer$renderTo$slambda_6(this));
        view_3.hbb(p_5, view_5);
        view_3.lbb(tmp_9, view_5);
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_6, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Frame())(view_2.pc());
        var tmp0_elvis_lhs_6 = view_2.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_2 : tmp0_elvis_lhs_6;
        view_2.gbb(p_6, view_6);
        if (get_viewIsWide(view_6)) {
          sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(5));
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextArea())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        if (this.rgw_1) {
          view_7.qb9();
        }
        view_7.zah(view_7.scl_1, this.ugw_1);
        view_6.hbb(p_7, view_7);
        if (get_viewIsWide(view_6)) {
          var tmp_10 = view_6.kbb(view_6.kbb(get_atBottomEnd(view_6), get_compact(view_6)), view_6.jbb(RemoveOutline_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_8 = new (RowOrCol())(view_6.pc());
          var tmp0_elvis_lhs_8 = view_6.ebb_1;
          var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
          view_6.gbb(p_8, view_8);
          view_8.zbm(false);
          clearButton(this, view_8);
          sendButton(this, view_8);
          view_6.hbb(p_8, view_8);
          view_6.lbb(tmp_10, view_8);
        }
        view_2.hbb(p_6, view_6);
        view.hbb(p_2, view_2);
        view.lbb(tmp_5, view_2);
        if (get_viewIsNarrow(view)) {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_9 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_9 = view.ebb_1;
          var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
          view.gbb(p_9, view_9);
          view_9.zbm(false);
          view_9.lbb(get_expanding(view_9), clearButton(this, view_9));
          view_9.lbb(get_expanding(view_9), sendButton(this, view_9));
          view.hbb(p_9, view_9);
        }
        writer.hbb(p, view);
        return view;
      }
      igx(writer, setTarget, $super) {
        setTarget = setTarget === VOID ? false : setTarget;
        return $super === VOID ? this.hgx(writer, setTarget) : $super.hgx.call(this, writer, setTarget);
      }
    }
    initMetadataForClass($, 'Renderer');
    RendererClass = $;
  }
  return RendererClass;
}
var DialogClass;
function Dialog() {
  if (DialogClass === VOID) {
    class $ {
      constructor(lens, project) {
        this.jgx_1 = lens;
        this.kgx_1 = project;
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(ProjectMessageThread$Dialog$render$slambda_0());
        view.gba(get_AppDimensions().zg1_1);
        var tmp = view.kbb(view.kbb(view.jbb(DialogSemantic_getInstance()), align(view, Align_Center_getInstance(), Align_Stretch_getInstance())), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_dp(3));
        var tmp_0 = get_padded(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.gba(div(get_AppDimensions().yg1_1, 2));
        var tmp_1 = view_1.jbb(RemoveOutline_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        title(view_2, this.kgx_1.b7b_1 + ' Messaging');
        view_2.lbb(get_expanding(view_2), (new (Renderer())(this.jgx_1, this.kgx_1.v7a_1, VOID, VOID, true)).igx(view_2));
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_1, view_2);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        var tmp_2 = view_0.kbb(get_atTopEnd(view_0), view_0.jbb(RemoveOutline_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var tmp$ret$7 = view_0.jbb(ButtonSemantic_getInstance());
        var tmp_3 = view_0.kbb(tmp_2, tmp$ret$7);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_3 = view_0.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.gbb(p_3, view_3);
        icon(view_3, Companion_getInstance_0().vcf_1, 'Close messages');
        onClick(view_3, 'Close Messages', VOID, ProjectMessageThread$Dialog$render$slambda_2());
        view_0.hbb(p_3, view_3);
        view_0.lbb(tmp_3, view_3);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'Dialog', VOID, VOID, [Page()]);
    DialogClass = $;
  }
  return DialogClass;
}
var ProjectMessageThreadClass;
function ProjectMessageThread() {
  if (ProjectMessageThreadClass === VOID) {
    class $ {
      constructor(project, lens) {
        this.nf6_1 = project;
        this.of6_1 = lens;
        var tmp = this;
        tmp.pf6_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.daj($this$remember.daj(get_session()).rfv_1.mft(this.nf6_1));
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b7b_1;
          return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        });
      }
      wcv() {
        return this.pf6_1;
      }
      wd6(_this__u8e3s4) {
        return (new (Renderer())(this.of6_1, this.nf6_1)).igx(_this__u8e3s4);
      }
    }
    initMetadataForClass($, 'ProjectMessageThread', VOID, VOID, [Page()]);
    ProjectMessageThreadClass = $;
  }
  return ProjectMessageThreadClass;
}
function projectMessages(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  if (get_viewIsNarrow(writer)) {
    sizeConstraints(writer, VOID, VOID, VOID, VOID, VOID, VOID, plus(get_AppDimensions().eg2_1, get_rem(8)));
  }
  return (new (Renderer())(_this__u8e3s4.tgj(), _this__u8e3s4.lf8())).hgx(writer, true);
}
//region block: exports
export {
  Dialog as Dialog1vemwbargnizv,
  ProjectMessageThread as ProjectMessageThread3bzm1pe4dp4n,
  projectMessages as projectMessagessyigyk9vqeti,
};
//endregion

//# sourceMappingURL=messages.mjs.map
